import LoadingCircle from "reports/components/simple/LoadingCircle";
import {
  PnlBreakdownWithMultiDataKey,
  ProcessGroupAndMachemetryIdsInput,
} from "reports/getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { isEmpty } from "lodash";
import { useState } from "react";
import { SummaryMetricInput } from "reports/utils/metricUtils";
import { PnlBreakdownGettersByProcessGroup } from "../../BespokeReports/Getters/PnlBreakdownGettersByProcessGroup";
import CardWrapperStyles from "../../CardWrapperStyles";
import {
  useGeAndLtFromUrl,
  useProcessGroupAndMachemetryIdList,
} from "../../reportUtils";
import { getPnlTimes } from "../PnLChart/pnlChartUtils";
import MetricAndPnLBreakdown from "./MetricAndPnLBreakdown";
import { BreakdownTypeEnum } from "./metricAndPnlBreakdownTypes";
import { MachineBreakdownsStyles } from "./MetricAndPnLBreakdowns";
import { useParams } from "react-router";
import { ReportParams } from "reports/types";

export function ProcessGroupPnlBreakdowns({
  processGroupList,
  processGroupListWithConstraint,
  summaryMetricsInputList,
  customHeader,
  customSubHeader,
  shouldExpand = true,
  shouldShowButterfly = true,
  showMetricTitle = false,
}: {
  processGroupList: string[];
  processGroupListWithConstraint?: ProcessGroupAndMachemetryIdsInput[];
  summaryMetricsInputList: SummaryMetricInput[];
  customHeader?: string;
  customSubHeader?: string;
  shouldExpand?: boolean;
  shouldShowButterfly?: boolean;
  showMetricTitle?: boolean;
}) {
  const [data, setData] = useState<PnlBreakdownWithMultiDataKey[]>([]);

  const processGroupsAndMachemetryIds = useProcessGroupAndMachemetryIdList({
    processGroupList,
  });

  const processGroupsAndMachemetryIdsOrConstraintMachines =
    processGroupListWithConstraint && processGroupsAndMachemetryIds
      ? processGroupListWithConstraint.concat(...processGroupsAndMachemetryIds)
      : processGroupListWithConstraint
        ? processGroupListWithConstraint
        : processGroupsAndMachemetryIds;

  const isDataLoaded =
    data.length === processGroupsAndMachemetryIdsOrConstraintMachines?.length;

  const { ckey: tenant } = useParams() as ReportParams;
  const { ge, lt } = useGeAndLtFromUrl();

  const header = customHeader ?? "Process Group Breakdown";
  const subHeader =
    customSubHeader ?? "Click on the process group to view the detailed report";

  const maxBreakdownHeaderLength = Math.max(
    ...(processGroupsAndMachemetryIdsOrConstraintMachines
      ? processGroupsAndMachemetryIdsOrConstraintMachines.map(
          ({ processGroupName }) => {
            return processGroupName.length;
          }
        )
      : [0])
  );

  return (
    <CardWrapperStyles>
      <MachineBreakdownsStyles>
        <PnlBreakdownGettersByProcessGroup
          processGroupsAndMachemetryIds={
            processGroupsAndMachemetryIdsOrConstraintMachines
          }
          setData={setData}
          ge={ge}
          lt={lt}
        />
        <div className="header">{header}</div>
        <div className="subHeader">{subHeader}</div>
        {!isEmpty(data) && isDataLoaded ? (
          data
            .sort((a, b) => a.multiDataKey.localeCompare(b.multiDataKey))
            .map((pnlBreakdown, index) => {
              const pnlTimes = getPnlTimes({ data: pnlBreakdown });
              const multiDataKey = pnlBreakdown.multiDataKey;
              return (
                <MetricAndPnLBreakdown
                  key={multiDataKey}
                  {...{
                    pnlBreakdown,
                    pnlTimes,
                    maxBreakdownHeaderLength,
                    summaryMetricsInputList,
                    shouldExpand,
                    shouldShowButterfly,
                    processId: "",
                  }}
                  processName={multiDataKey}
                  skuData={[]}
                  showMetricTitle={showMetricTitle || index === 0}
                  breakdownType={BreakdownTypeEnum.processGroup}
                  reportLink={`${window.location.protocol}//${window.location.host}/${tenant}/reports/eos/${multiDataKey}?ge=${ge}&lt=${lt}`}
                />
              );
            })
        ) : (
          <LoadingCircle />
        )}
      </MachineBreakdownsStyles>
    </CardWrapperStyles>
  );
}
